<template>
  <div>
    <h4>{{ message }}</h4>
    <p>{{ add_message }}</p>
    <div class="uk-child-width-1-3@l uk-child-width-1-2@m uk-grid-small uk-grid-match" uk-grid>

      <div v-for="(doc, index) in data.list" :key="index">
        <div class="uk-card uk-card-default uk-card-body uk-box-shadow-xlarge">
          <div class="uk-flex uk-flex-between" style="align-items: center">
            <div>
              <span uk-icon="icon: file-pdf; ratio: 2"></span>
              <router-link
                  :to="{
                                      name: 'docView',
                                      params: {
                                          url: docUrl(doc.id),
                                      },
                                      query: {
                                          is_online: doc.is_online
                                      }
                                  }">
                <h5 :class="[doc.bold ? 'navy-color': '', 'uk-display-inline']">{{ doc.name }}</h5>
              </router-link>
            </div>
            <input class="uk-checkbox uk-form-width-xsmall uk-form-small" v-model="doc.checked" type="checkbox"
                   @change="checkReqChecked()">
          </div>
        </div>
      </div>
    </div>
    <div class="uk-child-width-1-3@m uk-child-width-1-2@s uk-grid-small uk-grid-match uk-grid uk-grid-stack"
         uk-grid="">
      <div class="uk-form-horizontal uk-margin-large-top uk-first-column uk-width-1-1@s">
        <p v-if="res_text"
           :class="[res_text_style === 'error' ? 'uk-text-danger': 'uk-text-bold uk-text-emphasis', 'uk-margin-remove-top']">
          {{ res_text }}</p>
        <button v-if="data.show_sign_button" :disabled="disabledButton" @click="sign(true)"
                class="uk-button uk-button-primary uk-width-auto@s">
          {{ data.sign_button_caption }}
        </button>
        <button v-if="data.show_cancel_button" :disabled="disabledButton" @click="sign(false)"
                class="cancel-btn uk-button uk-button-secondary uk-width-auto@s">
          {{ data.cancel_button_caption }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "WebList",
  props: {
    docsetID: {required: true, type: String},
  },
  data() {
    return {
      data: {
        sign_button_caption: this.$t("continue"),
        cancel_button_caption: "",
        show_bankcard: 0,
        show_sign_button: 0,
        show_cancel_button: 0,
        list: [],
        ask_pin: 0
      },
      signing: false,
      required_checked: true,
      blank_list: [],
    };
  },
  created() {
    this.$http.get(`/${this.docsetID}/`).then(response => {
      this.data = response.data;
      this.set_add_message(response.data.add_message);
      this.set_message(response.data.message);
      this.setShowDocuments(response.data["show_documents"]);
      if (
          response.data["show_bankcard"] &&
          response.data["client_id"] &&
          response.data["bankcard_code"] === "bankcard.moneta"
      ) {
        this.user.id = response.data["client_id"];
        this.$router.push({
          name: "monetaIframe",
          params: {
            docsetID: this.docsetID
          }
        });
        return;
      }
      if (
          response.data["show_bankcard"] &&
          response.data["client_id"] &&
          response.data["bankcard_code"] === "bankcard.elcart"
      ) {
        this.$router.push({
          name: "creditCardForm",
          params: this.$route.params
        });
        return;
      }
      this.forward(response.data);
      this.checkReqChecked();
    }).catch(error => {
      if (error.response.status !== 401) {
        this.$router.push({
          name: "checkPinCode",
          params: this.$route.params,
        });
      }
    });
  },
  methods: {
    ...mapActions([
      "set_add_message",
      "set_message",
      "set_res_text",
      "set_res_text_style",
      "set_res_button_state",
      "setShowDocuments"
    ]),
    docUrl(docID) {
      return "/doc-detail/" + this.docsetID + "/" + docID + "/";
    },
    checkReqChecked() {
      /* eslint-disable no-console */
      console.log('Test');

      let required_blank_unchecked = false

      this.data.list.forEach((doc) => {
        console.log(`doc: ${doc}, doc.opt: ${doc.opt}, ${doc.checked}`)
        if (doc.checked) {
          if (!this.blank_list.includes(doc.id)) {
            this.blank_list.push(doc.id)
          }
        } else {
          if (this.blank_list.includes(doc.id)) {
            const docToRemove = this.blank_list.indexOf(doc.id);
            if (docToRemove !== -1) {
              this.blank_list.splice(docToRemove, 1);
            }
          }
        }
        if (doc.opt === 0 && !doc.checked) {
          console.log(`required_checked: ${this.required_checked}`);
          required_blank_unchecked = true
        }
      })

      if (required_blank_unchecked) {
        if (this.required_checked) {
          this.required_checked = false
        }

      } else {
        if (!this.required_checked) {
          {
            this.required_checked = true
          }
        }
      }
      console.log(this.required_checked, this.blank_list.join())
    },
    sign(s) {
      if (this.signing || this.data.show_bankcard) return;
      this.signing = true;
      this.checkReqChecked();
      this.$http.post("/", {
            uuid: this.user.docsetID,
            code: this.user.pinCode,
            blankList: this.blank_list.join(),
            isCancel: !s,
          }
      ).then(response => {
        this.set_res_text(response.data.res_text);
        this.set_res_text_style(response.data.res_text_style);
        this.set_res_button_state(response.data.res_button_state);
      }).catch(error => {
        this.set_res_text_style("error");
        this.set_res_text(error.response.statusText);
      }).then(() => {
        this.signing = false;
      });
    },
    forward(data) {
      if (
          data.show_sign_button === 0 &&
          data.show_bankcard === 0 &&
          data.list &&
          data.list.length === 1
      ) {
        this.$router.push({
          name: "docView",
          params: {
            url: this.docUrl(data.list[0].id),
          },
          query: {
            is_online: data.list[0].is_online
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "host",
      "add_message",
      "message",
      "res_text",
      "res_text_style",
      "res_button_state",
      "user"
    ]),
    disabledButton() {
      return this.res_button_state !== "enabled" || this.signing || !this.required_checked;
    }
  }
};
</script>

<style scoped>
.navy-color {
  color: #0000b1;
}

.uk-card a h5 {
  color: #0000b1;
}

.uk-card a:visited h5 {
  color: #000000;
}

@media screen and (max-width: 639px) {
  .cancel-btn {
    margin-top: 1rem;
  }
}

@media screen and (min-width: 640px) {
  .cancel-btn {
    margin-left: 1rem;
  }
}
</style>